import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import Select, { components } from "react-select";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { merchantValueSelector } from "./selector";
import { score } from "ccui-framework";

const Container = styled.div`
  flex: 2 1 0%;
  margin-left: 10px;
  margin-right: 25px;
`;

const Value = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0;

  img {
    width: 40px;
    height: 29px;
    margin-left: 2px;
  }

  span {
    margin-left: 5px;
    font-size: 11px;
  }
`;

const Options = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 10px;
  border-bottom: 2px solid #c7a878;

  img {
    width: 40px;
    height: 29px;
    margin-left: 5px;
  }

  span {
    margin-left: 5px;
  }
`;

const OptionsTxt = styled.div`
  flex: 1;
`;

const Merchant = styled.span`
  font-size: 10px;
`;
const SellPercentageTxt = styled.span`
  font-size: 9px;
  font-weight: 400;
`;

const MerchantSelector = forwardRef(
  ({ defaultValue = null, onChange = () => {} }, ref) => {
    const MERCHANT_OPTIONS = useSelector((state) =>
      merchantValueSelector(state)
    );
    const filterOption = (merchant, text) =>
      !!text ? score(merchant.data, text) : true;

    const ValueContainer = ({ children, ...props }) => (
      <components.ValueContainer {...props}>
        {props.hasValue ? (
          <Value>
            <img src={props.getValue()[0].image} />
            <span>{props.getValue()[0].label}</span>
          </Value>
        ) : (
          children
        )}
      </components.ValueContainer>
    );
    const OptionContainer = (props) => (
      <Options ref={props.innerRef} {...props.innerProps}>
        <img src={props.data.image} />
        <OptionsTxt>
          <Merchant>{props.data.label}</Merchant>
          <br />
          <SellPercentageTxt>
            Sell for {props.data.sellPercentage}% of the value.
          </SellPercentageTxt>
        </OptionsTxt>
      </Options>
    );

    return (
      <Container>
        <Select
          ref={ref}
          filterOption={filterOption}
          placeholder={"Brand Name"}
          value={defaultValue}
          onChange={onChange}
          options={MERCHANT_OPTIONS}
          isClearable={true}
          components={{ Option: OptionContainer, ValueContainer }}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: "#FFFFFF",
              primary: "#FFFFFF",
            },
          })}
          styles={{
            indicatorSeparator: (styles) => ({ ...styles, width: "0px" }),
            control: (styles) => ({
              ...styles,
              borderStyle: "none",
              borderWidth: "0px",
              borderRadius: "0px",
              borderBottom: `1px solid #c7a878`,
            }),
            menu: (styles) => ({
              ...styles,
              marginTop: "0px",
              borderRadius: "0 0 30px 30px",
              overflow: "hidden",
              borderStyle: "none",
            }),
            menuList: (styles) => ({
              ...styles,
              maxHeight: "14rem",
              overflowX: "hidden",
            }),
            placeholder: (styles) => ({
              ...styles,
              color: "#777984",
              fontSize: "14px",
              lineHeight: "24px",
              fontStyle: "normal",
              fontWeight: "500",
            }),
          }}
        />
      </Container>
    );
  }
);

const MerchantSelectorError = () => {
  const { isRequired } = useSelector((state) => state.merchantValidation);

  return <>{isRequired && <p className="errorMsg">Brand is Required!</p>}</>;
};

MerchantSelector.propTypes = {
  onChange: PropTypes.func.isRequired,

  defaultValue: PropTypes.object,
};
MerchantSelectorError.propTypes = {};

export { MerchantSelector, MerchantSelectorError };
